import { service } from '../../../../helpers/http' 

export const ActionGetUserSubscribers = ({ dispatch }, payload) => { 
    return service({
        module: 'domainUserSubscriber',
        action: 'getUserSubscribers',
        payload: payload
    })
}

export const ActionPostUserSubscribers = ({ dispatch }, payload) => {

    return service({
        module: 'domainUserSubscriber',
        action: 'postUserSubscribers',
        payload: payload
    })
    
}

export const ActionPutUserSubscribers = ({ dispatch }, payload) => {

    return service({
        module: 'domainUserSubscriber',
        action: 'putUserSubscribers',
        payload: payload
    })
    
}

export const ActionDeleteUserSubscribers = ({ dispatch }, payload) => {

    return service({
        module: 'domainUserSubscriber',
        action: 'deleteUserSubscribers',
        payload: payload
    })
    
}
